import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { ApellidoVariacion } from './ApellidoVariacion';
import { Apellido } from '../Apellidos/Apellido';

export interface IApellidoVariacionEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: ApellidoVariacion | undefined;
}

export interface IApellidoVariacionEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    apellidos: Apellido[];
}

export default class ApellidoVariacionEdit extends React.Component<IApellidoVariacionEditProps, IApellidoVariacionEditState> {
    _apellidoVariacion: ApellidoVariacion = new ApellidoVariacion();
    _id: number = -1;
    
    public constructor(props: IApellidoVariacionEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            apellidos: []
        }
    }

    componentDidMount(): void {
        this.GetApellidos();
    }

    componentWillReceiveProps(nextProps: Readonly<IApellidoVariacionEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._apellidoVariacion = nextProps.selectedItem;
            console.log(this._apellidoVariacion);
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Modificar nombre de pila
                </DialogTitle>
                <DialogContent>
                    {
                        this.state.hasErrors && (
                            <Alert severity="error" style={{marginBottom: '10px'}}>
                                {
                                    this.state.errorMessage
                                }
                            </Alert>
                        )
                    }
                    <Box>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <Autocomplete
                                defaultValue={this._apellidoVariacion.apellido}
                                options={this.GetAutocompleteOptions()}
                                onChange={(event: any, newValue: string) => {
                                    this._apellidoVariacion.apellido = newValue;
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Apellido" variant="standard"/>
                                )}
                            />
                        </FormControl>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Apellido' defaultValue={this._apellidoVariacion.variacion} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._apellidoVariacion.variacion = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Update.bind(this)}>OK</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._apellidoVariacion.variacion == '' || this._apellidoVariacion.apellido == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/apellidosvariaciones/${this._apellidoVariacion.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._apellidoVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellidoVariacion = new ApellidoVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._apellidoVariacion = new ApellidoVariacion();
        });
    }

    private GetApellidos(): void {
        let url = `${Common.END_POINT}/masters/apellidos`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    apellidos: response
                }
            );
        })
    }

    private GetAutocompleteOptions() {
        const options: any[] = [];

        for(let i = 0; i < this.state.apellidos.length; i++) {
            const apellido = this.state.apellidos[i];
            options.push(
                apellido.apellido
            )
        }

        return options;
    }
}